/**
 * Get the default translations for the data manager.
 *
 * @param {Object} t The translation method.
 * @param {Object} custom The customized translated string.
 *
 * @returns {Object} The translations.
 */
export default (t, custom = {}) => ({
  title: custom?.title || t('core:dataManager.title'),
  noData: custom?.noData || t('core:dataManager.noData'),
  search: {
    placeholder: custom?.search?.placeholder || t('core:dataManager.search.placeholder'),
  },
  footer: {
    pagination: custom?.footer?.pagination || t('core:dataManager.footer.pagination'),
    info: custom?.footer?.info || t('core:dataManager.footer.info'),
  },
  export: {
    idle: t('core:dataManager.export.idle'),
    loading: t('core:dataManager.export.loading'),
    success: t('core:dataManager.export.success'),
    error: t('core:dataManager.export.error'),
  },
});
